if (!customElements.get('product-popup-carousel')) {
  customElements.define(
    'product-popup-carousel',
    class ProductPopupCarousel extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.initCarousel();
      }

      initCarousel() {
        const carousel = this.querySelector('.carousel');
        const prevButton = this.querySelector('.carousel__prev');
        const nextButton = this.querySelector('.carousel__next');
        let currentSlide = 0;

        const scrollToSlide = (index) => {
          const slides = carousel.children;
          if (index < 0) index = slides.length - 1;
          if (index >= slides.length) index = 0;
          currentSlide = index;
          carousel.scrollTo({
            left: slides[index].offsetLeft,
            behavior: 'smooth',
          });
        };

        prevButton.addEventListener('click', () => scrollToSlide(currentSlide - 1));
        nextButton.addEventListener('click', () => scrollToSlide(currentSlide + 1));

        let isDown = false;
        let startX;
        let scrollLeft;
        let momentumID;

        carousel.addEventListener('mousedown', (e) => {
          isDown = true;
          carousel.classList.add('active');
          startX = e.pageX - carousel.offsetLeft;
          scrollLeft = carousel.scrollLeft;
          carousel.style.scrollSnapType = 'none'; // Disable scroll-snap during drag
          cancelMomentumTracking();
        });

        carousel.addEventListener('mouseleave', () => {
          if (isDown) {
            isDown = false;
            carousel.classList.remove('active');
            startMomentumTracking();
          }
        });

        carousel.addEventListener('mouseup', () => {
          if (isDown) {
            isDown = false;
            carousel.classList.remove('active');
            startMomentumTracking();
          }
        });

        carousel.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - carousel.offsetLeft;
          const walk = (x - startX) * 2; //scroll-fast
          carousel.scrollLeft = scrollLeft - walk;
        });

        const startMomentumTracking = () => {
          cancelMomentumTracking();
          momentumID = requestAnimationFrame(momentumLoop);
        };

        const cancelMomentumTracking = () => {
          cancelAnimationFrame(momentumID);
        };

        const momentumLoop = () => {
          if (isDown) return;
          setTimeout(() => {
            carousel.style.scrollSnapType = ''; // Re-enable scroll-snap after a short delay
          }, 300); // Adjust the delay as needed
          cancelMomentumTracking();
        };

        carousel.addEventListener('scroll', () => {
          if (!isDown) {
            const slides = carousel.children;
            let closestSlide = 0;
            let closestDistance = Math.abs(carousel.scrollLeft - slides[0].offsetLeft);
            for (let i = 1; i < slides.length; i++) {
              const distance = Math.abs(carousel.scrollLeft - slides[i].offsetLeft);
              if (distance < closestDistance) {
                closestSlide = i;
                closestDistance = distance;
              }
            }
            currentSlide = closestSlide;
          }
        });
      }
    }
  );
}
